export const POPULAR_DOMAINS = ["gmail.com", "hotmail.com", "yahoo.com"];

export const ALL_DOMAINS = [
  "gmail.com",
  "yahoo.com",
  "outlook.com",
  "hotmail.com",
  "icloud.com",
  "aol.com",
  "protonmail.com",
  "zoho.com",
  "gmx.com",
  "mail.com",
  "yandex.ru",
  "tutanota.com",
  "fastmail.com",
  "hushmail.com",
  "mail.ru",
  "inbox.ru",
  "list.ru",
  "bk.ru",
  "rediffmail.com",
  "sbcglobal.net",
  "att.net",
  "verizon.net",
  "comcast.net",
  "bellsouth.net",
  "bluebottle.com",
  "seznam.cz",
  "wanadoo.fr",
  "cdiscount.com",
  "gawab.com",
];
